import { useState, useCallback } from "react";
import REVIEWS from "./reviewsData";
import "./Reviews.css";

export const Reviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = useCallback(() => {
    setCurrentIndex((prev) => (prev === 0 ? REVIEWS.length - 1 : prev - 1));
  }, []);

  const handleNext = useCallback(() => {
    setCurrentIndex((prev) => (prev === REVIEWS.length - 1 ? 0 : prev + 1));
  }, []);

  const review = REVIEWS[currentIndex];

  return (
    <section className="reviews" id="reviews-section">
      <div className="col-md-12 text-center">
        <h2 class="secretMap__title">
          <img
            className="howitwrkicn"
            src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/image 94.png"
            alt=""
          />
          Loved by Kids. Trusted by Parents.
          <img
            className="howitwrkrgticn"
            src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/image 95.png"
            alt=""
          />
        </h2>
      </div>
      <div className="reviews__container">
        <div className="reviews__imageWrap">
          <img
            src={`${process.env.REACT_APP_CDN_URL}/static/homev2/Reviews.cd9ef9382f41f6d6ff4c.png`}
            alt="Happy family using Yuva Quest"
            className="reviews__image"
          />
        </div>

        <div className="reviews__content">
          {/* Opening quote */}
          <div className="reviews__quoteOpen" aria-hidden="true">
            &#x201C;
          </div>

          {/* Review text */}
          <p className="reviews__text">&ldquo;{review.comment}&rdquo;</p>

          {/* Reviewer name */}
          <p className="reviews__author">
            {review.name}, {review.role}
          </p>

          {/* Nav buttons */}
          <div className="reviews__nav">
            <button
              className="reviews__navBtn"
              onClick={handlePrev}
              aria-label="Previous review"
            >
              &lt;
            </button>
            <button
              className="reviews__navBtn"
              onClick={handleNext}
              aria-label="Next review"
            >
              &gt;
            </button>
          </div>

          {/* Closing quote */}
          <div className="reviews__quoteClose" aria-hidden="true">
            &#x201D;
          </div>
        </div>
      </div>
    </section>
  );
};
